import { colors, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 6,
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    cursor: 'grab',
    borderLeft: `4px solid transparent`,
    boxShadow: '0px 1px 3px rgba(0,0,0,0.08)',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  cardDragging: {
    boxShadow: theme.shadows[6],
    opacity: 0.95,
  },
  autoChip: {
    height: 18,
    marginLeft: theme.spacing(0.5),
    fontSize: 10,
    backgroundColor: colors.pink[100],
    color: colors.pink[900],
  },
  dpoChip: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.common.white,
    fontSize: 10,
    height: 16,
    fontWeight: 600,
    '& .MuiChip-label': {
      padding: '0 6px',
    },
  },
  cardReadOnly: {
    cursor: 'default',
    '&:active': {
      cursor: 'default',
    },
  },
  borderSevere: {
    borderLeftColor: theme.palette.error.main,
  },
  borderHigh: {
    borderLeftColor: theme.palette.warning.main,
  },
  borderMedium: {
    borderLeftColor: theme.palette.info.main,
  },
  borderLow: {
    borderLeftColor: theme.palette.success.main,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
  cardId: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  menuButton: {
    padding: 2,
    marginTop: -2,
    color: theme.palette.text.secondary,
  },
  cardTitle: {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  priorityLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  prioritySevere: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  priorityHigh: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  priorityMedium: {
    color: theme.palette.info.main,
    fontWeight: 600,
  },
  priorityLow: {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
  cardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(0.5),
  },
  responsible: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  cardIdRow: {
    gap: 4,
  },
  iconFixed: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  deadline: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  deadlineOverdue: {
    fontSize: 11,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    borderRadius: 4,
    padding: '1px 6px',
  },
}))

export default useStyles
